import { EventItem } from '@shared';

export interface EventsPagination {
  currentPage: number;
  totalPages: number;
  total: number;
  limit: number;
}

export interface EventsState {
  upcomingEvents: EventItem[];
  upcomingEventsPagination: EventsPagination;
  inPreparationEvents: EventItem[];
  inPreparationEventsPagination: EventsPagination;
  pastEvents: EventItem[];
  pastEventsPagination: EventsPagination;
  loading: boolean;
  loadingMoreUpcomingEvents: boolean;
  loadingMoreInPreparationEvents: boolean;
  loadingMorePastEvents: boolean;
  error: string | null;
}

export const initialEventsState: EventsState = {
  upcomingEvents: [],
  upcomingEventsPagination: {
    currentPage: 0,
    totalPages: 0,
    total: 0,
    limit: 20,
  },
  inPreparationEvents: [],
  inPreparationEventsPagination: {
    currentPage: 0,
    totalPages: 0,
    total: 0,
    limit: 20,
  },
  pastEvents: [],
  pastEventsPagination: {
    currentPage: 0,
    totalPages: 0,
    total: 0,
    limit: 20,
  },
  loading: false,
  loadingMoreUpcomingEvents: false,
  loadingMoreInPreparationEvents: false,
  loadingMorePastEvents: false,
  error: null,
};
